import { Goal, ID } from '@griply/types';

import { hasOpenTasks } from './has-open-tasks';

export type GetGoalTaskListGoalsOptions = {
  isGoalGrouping: boolean;
  taskCounts?: Map<ID, number>;
};

export const getGoalTaskListGoals = (
  goal: Goal | undefined,
  subGoals: Goal[],
  { isGoalGrouping, taskCounts }: GetGoalTaskListGoalsOptions,
): Goal[] => {
  if (!goal) {
    return [];
  }

  const visibleSubGoals = subGoals.filter(
    (subGoal) =>
      !(
        isGoalGrouping &&
        (subGoal.archivedAt ||
          (goal.hideCompletedTasks &&
            !!subGoal.completedAt &&
            !hasOpenTasks(subGoal.id, taskCounts)))
      ),
  );

  const goalSorting = goal.goalSorting;
  if (goalSorting?.length) {
    visibleSubGoals.sort(
      (a, b) =>
        (goalSorting.indexOf(a.id) + 1 || Number.MAX_VALUE) -
        (goalSorting.indexOf(b.id) + 1 || Number.MAX_VALUE),
    );
  }

  return [goal, ...visibleSubGoals];
};
